<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";

export default {
    name: "OrgChartNode4",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: {
        node: {
            type: Object,
            required: true
        }
    },
    computed: {
        member() {
            return this.node.sourceMember || this.node;
        }
    }
};
</script>

<template>
    <li>
        <div class="node-card">
            <!-- Image -->
            <div class="node-img">
                <PhotoBox class="photobox" :project="member" type="profile" :bgColor="'#f0f0f0'" objectFit="cover" />
            </div>

            <!-- Info -->
            <div class="node-info">
                <div class="name">
                    <SpellCheckedText :value="member.teamMemberName || ''" @input="member.teamMemberName = $event" />
                </div>

                <div class="role">
                    <SpellCheckedText :value="member.role || ''" @input="member.role = $event" />
                </div>
            </div>
        </div>

        <!-- Children -->
        <ul v-if="node.children && node.children.length">
            <OrgChartNode4 v-for="child in node.children" :key="child.teamMemberId" :node="child" />
        </ul>
    </li>
</template>

<style scoped lang="scss">
.node-card {
    width: 210px;
    height: 70px;
    border: 1.5px solid #1a1a3a;
    border-radius: 12px;
    display: inline-flex;
    overflow: hidden;
    position: relative;
    z-index: 10;
    background: var(--body-color);

    .node-img {
        width: 70px;
        height: 70px;
        background: #f0f0f0;
        flex-shrink: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .node-info {
        flex: 1;
        padding: 8px 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        text-align: left;

        .name {
            color: var(--label-color);
            font-size: var(--label-size);
            font-family: var(--label-font);
            font-weight: var(--label-weight-bold);
            font-style: var(--label-style);
            text-decoration: var(--label-decoration);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .role {
            color: var(--label-color);
            font-size: var(--label-size);
            font-family: var(--label-font);
            font-weight: var(--label-weight);
            font-style: var(--label-style);
            text-decoration: var(--label-decoration);
            line-height: 1.2;
            overflow: hidden;
        }
    }
}
</style>